<template>
    <div class="gpt-msg-screen-wrap">
        <div class="sender-msg wrap">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Great!</p>
                <p>Start by telling us the name of your conference and its theme</p>
                <p>or <v-btn @click="showsuggestion = !showsuggestion" outlined rounded color="#2376e5" class="suggest">Suggest a Name</v-btn></p>
                <div v-if="showsuggestion" class="name-suggestion">
                    <p class="mt-4 mb-3">Sure, here are some name suggestions for your upcoming event</p>
                    <ol>
                        <li>"Next Frontier: Exploring Leagal Innovation"</li>
                        <li>"Leadding Change: Empowering the legal Profession"</li>
                        <li>"The Future of Law: Empowering the legal Profession"</li>
                        <li>"Next Frontier: Exploring Leagal Innovation"</li>
                        <li>"Leadding Change: Empowering the legal Profession"</li>
                        <li>"The Future of Law: Empowering the legal Profession"</li>
                    </ol>
                </div>
                <p class="msg-time mt-3"><span>10:32 am</span></p>
                
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>
        <div class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>Name of the event is ‘Get Started Omaha - Presented by Husch Blackwell’</p>
                <p class="msg-time mt-3"><span>10:32 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>
        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>What are the dates and times of your conference?</p>
                <div class="mt-3">
                    <date-picker v-model="time2" type="datetime" class="mr-3" placeholder="Select Start Date and Time"></date-picker>
                    <date-picker v-model="time3" type="datetime" placeholder="Select End Date and Time"></date-picker>
                </div>
                <p class="msg-time mt-3"><span>10:33 am</span></p>
                
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>
        <div class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>The event will be held from 20th June to 22nd June 2023 from 10 am to 4 pm daily.</p>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>
        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>What type of event you want to host?</p>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
                <div class="event-types">
                    <div class="single-event-types">
                        <div class="event-type-name">
                            <p>Virtual</p>
                        </div>
                        <div class="event-type-image">
                            <img src="../assets/Images/chatgpt/virtual.svg" alt="Sender Image"/>
                        </div>
                    </div>
                    <div class="single-event-types">
                        <div class="event-type-name">
                            <p>Hybrid</p>
                        </div>
                        <div class="event-type-image">
                            <img src="../assets/Images/chatgpt/hybrid.svg" alt="Sender Image"/>
                        </div>
                    </div>
                    <div class="single-event-types">
                        <div class="event-type-name">
                            <p>In-Person</p>
                        </div>
                        <div class="event-type-image">
                            <img src="../assets/Images/chatgpt/inperson.svg" alt="Sender Image"/>
                        </div>
                    </div>
                </div>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>
        <div class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>In-Person</p>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>

        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>What is the location of your event?</p>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
                <div class="find-event-location">
                    <v-text-field label="Add location" :rules="rules" hide-details="auto"></v-text-field>
                    <v-btn outlined rounded color="#1a73e8" width="42%" class="location-button mr-3 mt-2">Find on Map</v-btn>
                    <v-btn outlined rounded color="#1a73e8" width="54%" class="location-button mt-2">Current Location (GPS)</v-btn>
                </div>
                <div class="event-location-map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1147.8277537005322!2d-122.4528823919586!3d37.76368402025643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858759dd4e1235%3A0x8b2dff7d3f01e5b0!2sWalgreens!5e0!3m2!1sen!2sin!4v1682663252671!5m2!1sen!2sin" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>
        <div class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>111 Congress Avenue, Suite 1400, Austin, TX 78701-4093</p>
                <p class="msg-time mt-3"><span>10:36 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>

        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Great!</p>
                <p>Let’s setup registrations and tickets for your events.</p>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
                
                <v-btn outlined rounded color="#1a73e8" width="168px" class="location-button mr-3 mt-2">Create Tickets</v-btn>
                <div class="ticket-creat-option">
                    <ul>
                        
                        <li><span class="d-inline-block mr-3"><v-btn fab outlined small color="#2376e5" @click="checkTicket()" ><v-icon color="#2376e5" v-if="!isClicked">mdi-plus</v-icon> <v-icon v-else color="#2376e5">mdi-check</v-icon></v-btn></span> Partners</li>
                        <li><span class="d-inline-block mr-3"><v-btn fab outlined small color="#2376e5" @click="checkTicket()"><v-icon color="#2376e5" v-if="!isClicked">mdi-plus</v-icon> <v-icon v-else color="#2376e5">mdi-check</v-icon></v-btn></span> Employees</li>
                        <li><span class="d-inline-block mr-3"><v-btn fab outlined small color="#2376e5" @click="checkTicket()"><v-icon color="#2376e5" v-if="!isClicked">mdi-plus</v-icon> <v-icon v-else color="#2376e5">mdi-check</v-icon></v-btn></span> Interns</li>
                        <li><span class="d-inline-block mr-3"><v-btn fab outlined small color="#2376e5"><v-icon color="#2376e5">mdi-plus</v-icon> <v-icon color="#2376e5" class="d-none">mdi-check</v-icon></v-btn></span> Early Bird</li>
                    </ul>
                    <v-btn rounded :disabled="!isClicked" @click="OpenTicketSuccess()" color="#2376e5" width="108px" class="selection-done">Done</v-btn>
                </div>
                <p class="msg-time mt-3"><span>10:34 am</span></p>

                <div :style="{ display: divVisible }">
                    <div class="tickets-created mt-3">
                        <div class="gpt-event-banner">
                            <img src="../assets/Images/chatgpt/gpt-event-banner.jpg" alt="event-banner"/>
                        </div>
                        <div class="ticket-created-msg">
                            <p>Tickets created successfully</p>
                            <v-btn text fab small><v-icon color="#2376e5" size="22px">mdi-open-in-new</v-icon></v-btn>
                        </div>
                    </div>
                </div>
                <p class="msg-time mt-3"><span>10:37 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>

        <div :style="{ display: divVisible }" class="sender-msg wrap mt-4">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="sender-description">
                <p>Okay, now let me know more details about the tickets like pricing, quantity max/min limits etc. or edit and update directly.</p>
                <p class="msg-time mt-3"><span>10:34 am</span></p>
                <div class="edit_msg_button">
                    <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
                </div>
                <div class="ticket-table">
                    <div class="single-ticket-table">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Min Limit</th>
                                    <th>Max Limit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><v-btn color="#89919b" fab outlined x-small><v-icon size="20px">mdi-close</v-icon></v-btn> Partners</td>
                                    <td><span>$100.00</span></td>
                                    <td><span>00</span></td>
                                    <td><span>00</span></td>
                                    <td><span>00</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="single-ticket-table">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Min Limit</th>
                                    <th>Max Limit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><v-btn color="#89919b" fab outlined x-small><v-icon size="20px">mdi-close</v-icon></v-btn> Employees</td>
                                    <td><span>$100.00</span></td>
                                    <td><span>00</span></td>
                                    <td><span>00</span></td>
                                    <td><span>00</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="single-ticket-table">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Min Limit</th>
                                    <th>Max Limit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><v-btn color="#89919b" fab outlined x-small><v-icon size="20px">mdi-close</v-icon></v-btn> Interns</td>
                                    <td><span>$100.00</span></td>
                                    <td><span>00</span></td>
                                    <td><span>00</span></td>
                                    <td><span>00</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="ticket-submit">
                        <v-btn color="#2376e5" rounded width="130px" @click="updatedTicket()">Submit</v-btn>
                    </div>

                    <p class="msg-time mt-3"><span>10:36am</span></p>
                </div>
            </div>
        </div>
        

        <div :style="{ display: divVisibleNew }" class="sender-msg wrap mt-4">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/sender.png" alt="Receiver msg"/>
            </div>
            <div class="sender-description">
                <p>Tickets have been created for your event.</p>
                <div class="tickets-created mt-3">
                    <div class="gpt-event-banner">
                        <img src="../assets/Images/chatgpt/gpt-event-banner.jpg" alt="event-banner"/>
                    </div>
                    <div class="ticket-created-msg">
                        <p>Get Started Omaha - Presented by Husch Blackwell</p>
                        <v-btn text fab small><v-icon color="#2376e5" size="22px">mdi-open-in-new</v-icon></v-btn>
                    </div>
                </div>
                <v-btn @click="showTicketOptions()" outlined rounded color="#2376e5" class="checkout-form-create">Start create Check-out forms</v-btn>
                <p class="msg-time mt-3"><span>10:38am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>

        <div class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>Create forms based on the above mentioned tickets.</p>
                <p class="msg-time mt-3"><span>10:41 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>

        <div v-if="showTicketOptionss" class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Certainly! Here are some suggested fields for the checkout forms for your upcoming event, based on the ticket types I suggested:</p>
                <p class="msg-time mt-3"><span>10:42am</span></p>
                <div class="ticket-form-wrap mt-4">
                    <div class="single-ticket-wrap">
                        <div class="single-ticket-header">
                            <h3>1. Partners</h3>
                            <div class="single-ticket-preview">
                                <v-btn outlined rounded color="#2376e5" width="130px" class="mr-3"><v-icon size="22px" color="#2376e5">mdi-eye-outline</v-icon> Preview</v-btn>
                                <v-btn @click="showEventPreview" outlined rounded color="#2376e5" width="100px"><v-icon size="22px" color="#2376e5">mdi-plus</v-icon> Add</v-btn>
                            </div>
                        </div>
                        <div class="single-ticket-options-desc mt-3">
                            <ul>
                                <li><span></span>Legal Service field (dropdown menu)</li>
                                <li><span></span>Full Name field (text field)</li>
                                <li><span></span>Email Address field (text field)</li>
                                <li><span></span>Phone Number field (text field)</li>
                                <li><span></span>Payment Information (Stripe)</li>
                            </ul>
                        </div>
                    </div>

                    <div class="single-ticket-wrap mt-5">
                        <div class="single-ticket-header">
                            <h3>2. Employees</h3>
                            <div class="single-ticket-preview">
                                <v-btn outlined rounded color="#2376e5" width="130px" class="mr-3"><v-icon size="22px" color="#2376e5">mdi-eye-outline</v-icon> Preview</v-btn>
                                <v-btn @click="showEventPreview" outlined rounded color="#2376e5" width="100px"><v-icon size="22px" color="#2376e5">mdi-plus</v-icon> Add</v-btn>
                            </div>
                        </div>
                        <div class="single-ticket-options-desc mt-3">
                            <ul>
                                <li><span></span>Full Name field (text field)</li>
                                <li><span></span>Email Address field (text field)</li>
                                <li><span></span>Phone Number field (text field)</li>
                                <li><span></span>Payment Information (Stripe)</li>
                            </ul>
                        </div>
                    </div>

                    <div class="single-ticket-wrap mt-5">
                        <div class="single-ticket-header">
                            <h3>3. Interns</h3>
                            <div class="single-ticket-preview">
                                <v-btn outlined rounded color="#2376e5" width="130px" class="mr-3"><v-icon size="22px" color="#2376e5">mdi-eye-outline</v-icon> Preview</v-btn>
                                <v-btn @click="showEventPreview" outlined rounded color="#2376e5" width="100px"><v-icon size="22px" color="#2376e5">mdi-plus</v-icon> Add</v-btn>
                            </div>
                        </div>
                        <div class="single-ticket-options-desc mt-3">
                            <ul>
                                <li><span></span>Full Name field (text field)</li>
                                <li><span></span>Email Address field (text field)</li>
                                <li><span></span>Phone Number field (text field)</li>
                                <li><span></span>Phone Number field (text field)</li>
                                <li><span></span>Payment Information (Stripe)</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <p class="msg-time mt-3"><span>10:43 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>


        <div v-if="eventCreateMsg" class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Nice! forms have been added to the respective tickets. Do you want to create a microsite for the event?</p>
                <v-btn @click="previewSquare()" rounded outlined color="#2376e5" class="mt-3">Create Microsite</v-btn>
                <p class="msg-time mt-3"><span>10:45 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>

        <div v-if="previewWindow" class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>The microsite has been created! Take a look.</p>
                <div class="image-event-preview">
                    <img src="../assets/Images/chatgpt/event-img.jpg" alt="event-img-preview"/>
                    <div class="overlay-preview">
                        <v-btn fab x-small text><v-icon color="#fff" size="25px">mdi-eye-outline</v-icon></v-btn>
                        <p>Preview</p>
                    </div>
                </div>
                <p class="msg-time mt-3"><span>10:45 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>
        
        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Great.</p>
                <p>What are the sessions you would like to include in your event?</p>
                <p class="msg-time mt-3"><span>10:48 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>

        <div class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>I want some agenda reference for my 3 days event.</p>
                <p class="msg-time mt-3"><span>10:50 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>

        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Sure, here are some prompts to help you create an agenda for your 3-day event:</p>
                <div class="agenda-plan-wrap">
                    <div class="single-agenda-wrap">
                        <h3 class="mt-4">Day 1: </h3>
                        <ol>
                            <li>Registration and check-in for attendees</li>
                            <li>Opening remarks by the event organizer or host</li>
                            <li>Keynote speech by a notable guest speaker</li>
                            <li>Panel discussion on a relevant topic in your industry</li>
                            <li>Lunch break and networking opportunities</li>
                            <li>Breakout sessions or workshops on specific topics</li>
                            <li>Happy hour or social event for attendees to network and socialize</li>
                        </ol>
                    </div>
                    <div class="single-agenda-wrap">
                        <h3 class="mt-5">Day 2: </h3>
                        <ol>
                            <li>Morning session with a focus on a specific aspect of the industry</li>
                            <li>Breakout sessions or workshops on related topics</li>
                            <li>Lunch break and networking opportunities</li>
                            <li>Interactive activities or games related to the industry</li>
                            <li>Afternoon session with a focus on another aspect of the industry</li>
                            <li>Panel discussion with industry experts</li>
                            <li>Dinner reception or party for attendees to unwind and network</li>
                        </ol>
                    </div>
                    <div class="single-agenda-wrap">
                        <h3 class="mt-5">Day 3: </h3>
                        <ol>
                            <li>Morning session on the future of the industry or emerging trends</li>
                            <li>Breakout sessions or workshops on related topics</li>
                            <li>Lunch break and networking opportunities</li>
                            <li>Presentation or showcase of new products or innovations in the industry</li>
                            <li>Closing remarks by the event organizer or host</li>
                            <li>Farewell happy hour or social event for attendees to say goodbye and network before departing.</li>
                        </ol>
                    </div>
                </div>
                <p class="msg-time mt-3"><span>10:52 am</span></p>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>


        <div class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>Create the agenda based on our business. Husch Blackwell is a law firm that provides a wide range of legal services to clients across various industries, including healthcare, energy, construction, financial services, and more</p>
                <p class="msg-time mt-3"><span>10:54 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>

        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Sure, here's an example agenda for a 3-day event hosted by a law firm that provides a wide range of legal services to clients across various industries:</p>
                <div class="agenda-plan-wrap">
                    <div class="single-ticket-options-desc mt-3">
                        <h3 class="mt-5">Day 1: </h3>
                        <ul>
                            <li><span></span>Morning: Registration and welcome</li>
                            <li><span></span>Mid-morning: Opening keynote speaker or panel discussion on the current state of the legal landscape across various industries</li>
                            <li><span></span>Lunch: Networking lunch</li>
                            <li><span></span>Afternoon: Breakout sessions or workshops on specific legal topics related to various industries (e.g. intellectual property, employment law, contracts, etc.)</li>
                            <li><span></span>Evening: Reception or social event for attendees to network and mingle</li>
                        </ul>
                    </div>
                    <div class="single-ticket-options-desc mt-3">
                        <h3 class="mt-5">Day 2: </h3>
                        <ul>
                            <li><span></span>Morning: Keynote speaker or panel discussion on recent legal developments in a specific industry (e.g. healthcare, technology, finance, etc.)</li>
                            <li><span></span>Mid-morning: Breakout sessions or workshops focused on the legal challenges faced by clients in different industries</li>
                            <li><span></span>Lunch: Networking lunch</li>
                            <li><span></span>Afternoon: More breakout sessions or workshops on industry-specific legal topics</li>
                            <li><span></span>Evening: Optional group activity, such as a tour or excursion to explore the local area </li>
                        </ul>
                    </div>
                    <div class="single-ticket-options-desc mt-3">
                        <h3 class="mt-5">Day 3: </h3>
                        <ul>
                            <li><span></span>Morning: Keynote speaker or panel discussion on emerging legal trends and their potential impact on clients in various industries</li>
                            <li><span></span>Mid-morning: Final breakout sessions or workshops on topics such as compliance, risk management, and dispute resolution</li>
                            <li><span></span>Lunch: Networking lunch</li>
                            <li><span></span>Afternoon: Closing keynote speaker or panel discussion summarizing the main takeaways from the event and outlining the firm's approach to serving clients across different industries</li>
                            <li><span></span>Evening: Farewell dinner or party to celebrate the success of the event and give attendees a chance to say goodbye </li>
                        </ul>
                    </div>
                    <v-btn v-if="hidePopupTrigger" @click="SuccessAddAgenda()" rounded color="#2376e5" width = "100px" class="add-agenda-btn">Add</v-btn>
                </div>
                <div :style="{ display: divVisibleNewTwo }">
                    <div class="tickets-created mt-3">
                        <div class="gpt-event-banner">
                            <img src="../assets/Images/chatgpt/gpt-event-banner.jpg" alt="event-banner"/>
                        </div>
                        <div class="ticket-created-msg">
                            <p>Agenda created successfully</p>
                            <v-btn text fab small><v-icon color="#2376e5" size="22px">mdi-open-in-new</v-icon></v-btn>
                        </div>
                    </div>
                </div>
                <p class="msg-time mt-3"><span>10:54 am</span></p>
                
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>

        <div class="sender-msg wrap mt-4">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Who are the keynote speakers or special guests you would like to feature at your event?</p>
                <v-btn @click="openSpeakerSuggestion()" rounded outlined color="#2376e5" class="suggest_speaker_name mt-3">Suggest Speaker</v-btn>
            </div>
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>

        <div v-if="speakerSuggest" class="receiver-msg-wrap">
            <div class="receiver-img">
                <img src="../assets/Images/chatgpt/receiver.png" alt="Receiver msg"/>
            </div>
            <div class="receiver_description">
                <p>Suggest some speakers for the mid morning session of Day 1</p>
                <p class="msg-time mt-3"><span>10:56 am</span></p>
            </div>
            <div class="edit_msg_button">
                <v-btn elevation="0" icon text><v-icon size="22px" color="#666d77">mdi-square-edit-outline</v-icon></v-btn>
            </div>
        </div>

        <div v-if="speakerSuggest" class="sender-msg wrap mt-4 position-relative">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Here are some suggestions for speakers who could provide valuable insights on the legal challenges faced by clients in different industries:</p>

                <div class="gpt-speaker-wrap-area">
                    <div class="gpt-single-speaker mt-4">
                        <h4>Mary Jo White <a href="#">View Profile <v-icon color="#2376e5" size="22px">mdi-open-in-new</v-icon></a></h4>
                        <p>Former Chair of the Securities and Exchange Commission (SEC) and currently a litigation partner at Debevoise & Plimpton, where she advises clients on securities litigation, regulatory investigations and other legal challenges faced by corporations.</p>
                        <v-btn @click="addSpeakerEvent()" color="#2376e5" outlined rounded class="mt-2"><span v-if="!ifClicked"><v-icon color="#2376e5" size="22px">mdi-plus</v-icon> Add</span> <span v-else>Added</span></v-btn>
                    </div>
                    <div class="gpt-single-speaker mt-4">
                        <h4>Mark Geragos <a href="#">View Profile <v-icon color="#2376e5" size="22px">mdi-open-in-new</v-icon></a></h4>
                        <p>A prominent criminal defense attorney who has represented high-profile clients in various industries, including entertainment, sports, and technology.</p>
                        <v-btn @click="addSpeakerEvent()" color="#2376e5" outlined rounded class="mt-2"><span v-if="!ifClicked"><v-icon color="#2376e5" size="22px">mdi-plus</v-icon> Add</span> <span v-else>Added</span></v-btn>
                    </div>
                    <div class="gpt-single-speaker mt-4">
                        <h4>Julie Brill <a href="#">View Profile <v-icon color="#2376e5" size="22px">mdi-open-in-new</v-icon></a></h4>
                        <p>An attorney and former commissioner of the Federal Trade Commission (FTC) who is an expert in privacy and data security law. She currently serves as the Chief Privacy Officer and Corporate Vice President for Global Privacy and Regulatory Affairs at Microsoft.</p>
                        <v-btn color="#2376e5" outlined rounded class="mt-2"><v-icon color="#2376e5" size="22px">mdi-plus</v-icon> Add</v-btn>
                    </div>
                </div>

                <v-alert v-if="speakerCountAlert" dense width="160px" color="#2376e5" class="speaker_count_alert rounded-pill"><span class="speaker-numbers">2</span> Add Speakers</v-alert>
                <p class="msg-time mt-3"><span>10:56 am</span></p>
            </div>
            
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
        </div>


        <div v-if="brandingBox" class="sender-msg wrap mt-4 position-relative">
            <div class="sender-icon">
                <img src="../assets/Images/chatgpt/sender.png" alt="Sender Image"/>
            </div>
            <div class="sender-description">
                <p>Sessions have been created for your event.</p>
                <div class="tickets-created mt-3">
                    <div class="gpt-event-banner">
                        <img src="../assets/Images/chatgpt/gpt-event-banner.jpg" alt="event-banner"/>
                        <v-btn @click="openBrandingDrawer()" fab color="#fff" x-small class="button_branding"><img src="../assets/Images/chatgpt/effect.png"/></v-btn>
                    </div>
                    <div class="ticket-created-msg">
                        <p>Speaker added successfully</p>
                        <v-btn text fab small><v-icon color="#2376e5" size="22px">mdi-open-in-new</v-icon></v-btn>
                    </div>
                </div>
                <v-btn color="#2376e5" rounded outlined class="mt-3">Start Create Branding</v-btn>
                <p class="msg-time mt-3"><span>10:56 am</span></p>
            </div>
            
            <div class="reaction-section">
                <v-icon size="22px" color="#858b93" class="mr-3">mdi-thumb-up-outline</v-icon>
                <v-icon size="22px" color="#858b93">mdi-thumb-down-outline</v-icon>
            </div>
            <ChatGptBrandingDrawer v-if="brandingDrawer"/>
        </div>



        <v-dialog v-model="dialogTicket" width="350">
            <v-card>
                <div class="ticket-booking-success">
                    <div class="check-circle"><v-icon color="#2376e5" size="24px">mdi-check</v-icon></div>
                    <h6>3 ticket types have<br/>been added</h6>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogTicketUpdated" width="350">
            <v-card>
                <div class="ticket-booking-success">
                    <div class="check-circle"><v-icon color="#2376e5" size="24px">mdi-check</v-icon></div>
                    <h6>5 ticket types have<br/>been added</h6>
                </div>

            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAgendaAdd" width="350">
            <v-card>
                <div class="ticket-booking-success">
                    <div class="check-circle"><v-icon color="#2376e5" size="24px">mdi-check</v-icon></div>
                    <h6>Agenda have been successfully added to your event</h6>
                </div>

            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogSpeakeraAdd" width="350">
            <v-card>
                <div class="ticket-booking-success">
                    <div class="check-circle"><v-icon color="#2376e5" size="24px">mdi-check</v-icon></div>
                    <h6>2 speakers have been<br/>successfully added!</h6>
                </div>

            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ChatGptBrandingDrawer from "./ChatGptBrandingDrawer";
export default {
    components: {
        DatePicker,
        ChatGptBrandingDrawer,
    },
    props: {
        
    },
    data() {
        return {
            showsuggestion:  false,
            time2: null,
            time3: null,
            rules: [
                value => !!value || 'Required.',
            ],
            isClicked: false,
            ifClicked: false,
            dialogTicket: false,
            divVisible: 'none',
            dialogTicketUpdated: false,
            divVisibleNew: 'none',
            showTicketOptionss: false,
            eventCreateMsg: false,
            previewWindow: false,
            dialogAgendaAdd: false,
            divVisibleNewTwo: 'none',
            hidePopupTrigger: true,
            speakerCountAlert: false,
            dialogSpeakeraAdd: false,
            brandingDrawer: false,
            speakerSuggest: false,
            brandingBox: false,
        }
    },
    computed: { 
    },
    created() {},
    mounted() {},
    methods: {
        checkTicket(){
            this.isClicked = this.isClicked ? false : true;
        },
        OpenTicketSuccess(){
            this.dialogTicket = true;
            this.divVisible = 'none';
            setTimeout(() => {
                this.dialogTicket = false;
                this.divVisible = 'flex';
            }, 3000); // close after 3 seconds
        },
        updatedTicket(){
            this.dialogTicketUpdated = true;
            this.divVisibleNew = 'none';
            setTimeout(() => {
                this.dialogTicketUpdated = false;
                this.divVisibleNew = 'flex';
            }, 3000); // close after 3 seconds
        },
        showTicketOptions(){
            this.showTicketOptionss = true;
        },
        showEventPreview(){
            this.eventCreateMsg = true;
        },
        previewSquare(){
            this.previewWindow = true;
        },
        SuccessAddAgenda(){
            this.dialogAgendaAdd = true;
            this.divVisibleNewTwo = 'none';
            setTimeout(() => {
                this.dialogAgendaAdd = false;
                this.divVisibleNewTwo = 'flex';
                this.hidePopupTrigger = false;
            }, 3000);
        },
        addSpeakerEvent(){
            this.ifClicked = this.ifClicked ? false : true;
            if(this.ifClicked){
                this.speakerCountAlert = true;
            }
            else{
                this.speakerCountAlert = false;
            }
            setTimeout(() => {
                this.speakerCountAlert = false;
                this.dialogSpeakeraAdd = true;
                setTimeout(() => {
                this.dialogSpeakeraAdd = false;
                this.brandingBox = true;
                },3000); //dialog will close after 3 seconds
            },5000); //dialog will close after 5 seconds
        },
        openSpeakerSuggestion(){
            this.speakerSuggest = true;
        },
        openBrandingDrawer(){
            this.brandingDrawer = true;
        }
    },
    watch: {
    },

}
</script>
<style lang="scss">
@import '~vue2-datepicker/scss/index.scss';

$namespace: 'xmx'; // change the 'mx' to 'xmx'. then <date-picker prefix-class="xmx" />

$default-color: #555;
$primary-color: #1284e7;
</style>
